<template>
  <div class="vx-card p-6">
    <div>
      <h1 style="font-size: 40px; text-align: center; font-weight: 600; margin: 20px auto;">
        Destek Yönetimi
      </h1>
    </div>

    <form style="width: 100%;" class="pb-2 pt-2" @submit.prevent="GetSupportTicket()">
      <div class="vx-row pl-1 pt-2 pr-5">
        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm"><b>Ticket Id</b></label>
          <vs-input type="number" class="w-full" size="large" v-model="searchModel.supportTicketId" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <label class="text-sm"><b>Müşteri Id</b></label>
          <vs-input type="number" class="w-full" size="large" v-model="searchModel.customerId" />
        </div>
        <div class="vx-col md:w-1/6 w-full">
          <label class="text-sm"><b>Kaydı Giren Personel</b></label>
          <v-select @input="GetSupportTicket()" placeholder="Seçiniz" label="userName" :options="personnelList" v-model="searchModel.userId" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col md:w-1/6 w-full">
          <label class="text-sm"><b>Destek Türü</b></label>
          <v-select @input="GetSupportTicket()" placeholder="Seçiniz" label="name" :options="supportTypeList" v-model="searchModel.type" :reduce="(row) => row.value">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>

        <div class="vx-col md:w-1/6 w-full mt-5">
          <b><vs-checkbox v-model="searchModel.isActive" @input="GetSupportTicket()">Aktif</vs-checkbox></b>
        </div>
      </div>
      <!---->
      <div class="vx-row pl-1 pt-1 pr-5 mt-3">
        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm"><b>Durum</b></label>
          <v-select @input="GetSupportTicket()" placeholder="Seçiniz" label="name" :options="supportStatusList" v-model="searchModel.status" :reduce="(row) => row.value">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>

        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm"><b>Başlangıç</b></label>
          <vs-input type="date" size="medium" class="w-full" v-model="searchModel.startDate" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm"><b>Bitiş</b></label>
          <vs-input @change="GetSupportTicket()" type="date" size="medium" class="w-full" v-model="searchModel.finishDate" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm"><b>Atanan Personel</b></label>
          <v-select @input="GetSupportTicket()" placeholder="Seçiniz" label="userName" :options="personnelList" v-model="searchModel.assignUserId" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
      </div>
      <div class="satis-buton w-full tFlex tFlex_column tFlex_ai-c mt-5">
        <vs-button class="vx-col md:w-1/4 w-full mb-4" style=""> Detaylı Ara</vs-button>
        <p class="text-center md:w-1/4 mb-4"></p>
        <vs-button
          class="vx-col md:w-1/4 w-full mb-4"
          @click.stop="
            supportTicketPopupParent = true;
            selectedTicketId = null;
          "
          >Destek Kaydı</vs-button
        >
        <ticket-popup :supportTicketPopupProp="supportTicketPopupParent" :supportTicketIdProp="selectedTicketId" @supportTicketPopupClosed="SupportTicketPopupClosed($event)"></ticket-popup>
      </div>
    </form>

    <div class="vx-row w-full">
      <div class="vx-col w-full">
        <vs-table search :maxItems="10" :pagination="true" :data="ticketList">
          <template slot="thead">
            <vs-th width="75px">Id</vs-th>
            <vs-th width="150px">Müşteri</vs-th>
            <vs-th width="250px">Geçen Süre</vs-th>
            <vs-th width="150px">Oluşturan</vs-th>
            <vs-th width="150px">Oluşturma Tarihi</vs-th>
            <vs-th width="150px">Atanan</vs-th>
            <vs-th width="150px">Atama Tarihi</vs-th>
            <vs-th width="150px">Sonuçlandıran</vs-th>
            <vs-th width="150px">Sonuçlandırma Tarihi</vs-th>
            <vs-th width="170px">Durum</vs-th>
            <vs-th width="170px">Destek Tür</vs-th>
            <vs-th width="150px">Aciliyet</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody
              style="cursor: pointer;"
              :key="tr.supportTicketId"
              v-for="(tr, i) in data"
              @click="
                selectedTicketId = tr.supportTicketId;
                supportTicketPopupParent = true;
              "
            >
              <vs-tr :state="tr.status == 'Solved' ? 'success' : 'danger'">
                <template>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.supportTicketId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <a :href="'/contactsView/' + tr.customerId" target="_blank">
                      <b> {{ tr.customerName }}</b></a
                    >
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.day + " Gün " + tr.hour + " Saat " + tr.minute + " Dakika " + tr.second + " Saniye" }}
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <vs-input readonly type="text" style="width: 150px;" v-model="tr.userName" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <vs-input readonly type="text" style="width: 150px;" v-model="tr.date" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <vs-input readonly type="text" style="width: 150px;" v-model="tr.assignUserName" />
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <vs-input readonly="true" type="text" style="width: 150px;" v-model="tr.assignDate" />
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <vs-input readonly type="text" style="width: 150px;" v-model="tr.closeUserName" />
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <vs-input readonly="true" type="text" style="width: 150px;" v-model="tr.closeDate" />
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <v-select v-model="tr.status" disabled placeholder="Öncelik" :options="supportStatusList" label="name" class="w-full" :reduce="(row) => row.value">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <v-select v-model="tr.type" disabled placeholder="Öncelik" :options="supportTypeList" label="name" class="w-full" :reduce="(row) => row.value">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <v-select v-model="tr.priority" disabled placeholder="Öncelik" :options="priorityList" label="name" class="w-full" :reduce="(row) => row.value">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>

                  <td v-if="1 == 2">
                    <a href="" @click.prevent="SaveProject(tr, 'Delete', 'Proje silinecek ve ekli dosya var ise bir daha erişilemeyecektir.')" style="color: red; font-size: 10px;"><b class="mr-5">Sil</b></a>
                    <a href="" @click.prevent="SaveProject(tr, 'Update', '')" style="color: orange; font-size: 10px;"><b class="mr-5">Güncelle</b></a>
                    <a
                      href=""
                      @click.prevent="
                        popupDetailAndFile = true;
                        selectedProjectItem = tr;
                      "
                      style="color: navy; font-size: 10px;"
                      ><b class="mr-5" style="white-space: nowrap;">Detay & Dosya</b></a
                    >
                    <a
                      href=""
                      @click.prevent="
                        selectedProjectItem = tr;
                        GetHRProjectAssign();
                        popupAssignment = true;
                      "
                      style="color: darkgray; font-size: 10px;"
                      ><b class="mr-5" style="white-space: nowrap;">Görevler</b></a
                    >
                  </td>
                </template>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import TicketPopup from "./TicketPopup.vue";
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
export default {
  components: {
    TicketPopup,
    vSelect,
  },
  data() {
    return {
      selectedTicketId: null,
      name: "supportTicketModule",
      supportStatusList: [
        { name: "Yeni Kayıt", value: "Opened" },
        { name: "Beklemede", value: "Waiting" },
        { name: "Meşgul - Ulaşılamadı", value: "Busy" },
        { name: "Üreticiye Gönderildi", value: "SentToSupplier" },
        { name: "Onarımda", value: "Repairing" },
        { name: "Ödeme Bekleniyor", value: "AwaitingPayment" },
        { name: "Çözüldü", value: "Solved" },
      ],
      supportTypeList: [
        { name: "Yardım", value: "Help" },
        { name: "Kurulum", value: "Setup" },
        { name: "Güncelleme", value: "Update" },
        { name: "Aktivasyon", value: "Activation" },
        { name: "Hata", value: "Error" },
        { name: "Satış", value: "Sale" },
      ],
      priorityList: [
        { name: "Acil", value: "Urgent" },
        { name: "Yüksek", value: "High" },
        { name: "Normal", value: "Normal" },
        { name: "Düşük", value: "Low" },
      ],
      supportTicketPopupParent: false,
      ticketList: [],
      searchQuery: null,
      searchModel: { isActive: true },
      personnelList: [],
      pageSize: 20,
      currentPage: 1,
      pageStr: "",
      orderTypeList: [],
      autoRefresh: false,
      windowWidth: window.innerWidth,
      progressBarCurrent: 0,
      progressBarTotal: 0,
      transferPopupVisible: false,
      currentPageData: [],
      neighbours: [],
      matchedField: "",
      filteredItemCount: 0,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
    };
  },

  watch: {},
  computed: {},
  methods: {
    GetSupportTicket: async function () {
      this.$vs.loading();
      this.ticketList = await repository.postEntity("Support/GetSupportTicket", this.searchModel).then((r) => r.list);
      this.$vs.loading.close();
    },

    SupportTicketPopupClosed: async function (v) {
      this.supportTicketPopupParent = false;
      console.log("child is closed", v);
      this.GetSupportTicket();
    },

    isNumeric() {
      let c = parseInt(this.currentPage);
      if (isNaN(c)) c = 1;
      this.currentPage = c;
    },

    getUsers: async function () {
      this.personnelList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },
  },
  created() {
    if (this.$route.params != null && this.$route.name == "SupportTicketByCustomerId" && this.$route.params.customerId > 0) {
      this.searchModel.customerId = parseInt(this.$route.params.customerId);
    } else if (this.$route.params != null && this.$route.name == "SupportTicketById" && this.$route.params.supportTicketId > 0) {
      this.searchModel.supportTicketId = parseInt(this.$route.params.supportTicketId);
    } else if (this.$route.params != null && this.$route.name == "SupportTicketByUserId" && this.$route.params.userId > 0) {
      this.searchModel.userId = parseInt(this.$route.params.userId);
    } else if (this.$route.params != null && this.$route.name == "SupportTicketByAssignUserId" && this.$route.params.assignUserId > 0) {
      this.searchModel.assignUserId = parseInt(this.$route.params.assignUserId);
    }
    Promise.all([this.GetSupportTicket(), this.getUsers()]);
  },
};
</script>

<style lang="scss" scoped></style>
